import { render, staticRenderFns } from "./fplace.vue?vue&type=template&id=f6d7d4d8&scoped=true"
import script from "./fplace.vue?vue&type=script&lang=js"
export * from "./fplace.vue?vue&type=script&lang=js"
import style0 from "./fplace.vue?vue&type=style&index=0&id=f6d7d4d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d7d4d8",
  null
  
)

export default component.exports